import 'flickity/dist/flickity.pkgd'
import vidim from 'vidim/dist/vidim'

window.vidim = vidim

var splashSlider = jQuery('.splash__holder'),
    splashSlides = jQuery('.splash__holder .splash')

let splashVideoPrev

let height = jQuery(window).height() - jQuery('.header').height()

splashSlides.css( { 'display' : 'flex'} )
splashSlider.css( { 'height'  : height } )
splashSlides.css( { 'height'  : height } )

if ( height < 510 )
    jQuery( '.splash__content' ).css( { 'padding-bottom' : '80px' } )

if (splashSlider.length > 0 && splashSlides.length > 1) {

    splashSlider.flickity({
        cellSelector: '.splash',
        prevNextButtons: false,
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left',
        setGallerySize: false,
    })

    setTimeout(function () {
        splashSlider.flickity('select', 0)
    }, 3000)

    let splashSliderData = splashSlider.data('flickity')

    splashSlider.on('select.flickity', function () {
        if (splashVideoPrev !== undefined) {
            splashVideoPrev.pause()
        }

        if (jQuery(splashSliderData.selectedElement).hasClass('splash--video')) {

            splashVideoPrev = window[`splash${splashSliderData.selectedIndex}`]
            window[`splash${splashSliderData.selectedIndex}`].play()

        }
    })
}

const partnersSlider = jQuery('.logo-bar'),
    partnersSlides = jQuery('.logo-bar .partner-logo')

if (partnersSlider.length > 0 && partnersSlides.length > 1) {

    partnersSlider.flickity({
        cellSelector : '.partner-logo',
        wrapAround   : true,
        cellAlign    : 'left',
        groupCells   : true,
        autoPlay     : true,
        draggable    : false,
    })

}

let featuredSidebar = jQuery('.featured__sidebar').detach()

jQuery(window).on('resize', _.debounce(function () {

    if ( window.matchMedia( "(min-width: 768px)" ).matches && window.matchMedia( "(max-width: 1023px)" ).matches )
        featuredSidebar.appendTo('.featured__news')
    else
        featuredSidebar.appendTo('.featured')


    let height = jQuery(window).height() - jQuery('.header').height()

    splashSlider.css( { 'height' : height } )
    splashSlides.css( { 'height' : height } )

    if ( height < 510 ) {
        jQuery( '.splash__content' ).css( { 'padding-bottom' : '80px' } )
    }
}, 1000))

jQuery(document).ready(function () {

    if ( window.matchMedia( "(min-width: 768px)" ).matches && window.matchMedia("(max-width: 1023px)").matches )
        featuredSidebar.appendTo('.featured__news')
    else
        featuredSidebar.appendTo('.featured')

})
